import { post } from '../utils/fetch';
import { apiUserSurveyPath } from 'routing/routes';
import OptionalUserSurvey from 'models/OptionalUserSurvey';

export const createUserSurvey = (userSurvey: OptionalUserSurvey) =>
  post(apiUserSurveyPath, userSurvey);
